import { PRODUCTS_STATUS } from '@/consts/product-settings';

// Ativo fica sem sufixo: é quase toda a lista, e o sufixo só chama atenção como exceção.
// `all` é opção do filtro da listagem, não status de produto.
const STATUSES_WITHOUT_SUFFIX = ['active', 'all'];

export function formatProductNameWithStatus(name = '', status) {
  const statusLabel = !STATUSES_WITHOUT_SUFFIX.includes(status) && PRODUCTS_STATUS[status]?.label;

  return statusLabel ? `${name} (${statusLabel})` : name;
}
